var _path, _rect, _rect2, _rect3, _rect4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#87BDF4"
    },
    d: "M512,256c0,141.241-114.759,256-256,256S0,397.241,0,256S114.759,0,256,0S512,114.759,512,256"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8C787"
    },
    d: "M308.966,105.931C267.476,86.51,256,0,256,0s-11.476,86.51-52.966,105.931H308.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8C787"
    },
    d: "M335.448,450.207H176.552v49.434C201.269,507.586,228.634,512,256,512s54.731-4.414,79.448-12.359 V450.207z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD6A4"
    },
    d: "M326.621,158.897H185.379l16.772-56.497c0.883-2.648,3.531-5.297,6.179-5.297h95.338 c2.648,0,5.297,1.766,6.179,5.297L326.621,158.897z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD6A4"
    },
    points: "132.414,450.207 379.586,450.207 379.586,203.034 132.414,203.034  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.103,326.621c0,53.848-43.255,97.103-97.103,97.103s-97.103-43.255-97.103-97.103 s43.255-97.103,97.103-97.103S353.103,272.772,353.103,326.621"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.31,388.414c-2.648,0-4.414-0.883-6.179-2.648l-35.31-35.31c-1.766-1.766-2.648-3.531-2.648-6.179v-61.793 c0-5.297,3.531-8.828,8.828-8.828c5.297,0,8.828,3.531,8.828,8.828v58.262l32.662,32.662c3.531,3.531,3.531,8.828,0,12.359 C295.724,387.531,293.959,388.414,291.31,388.414z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 247.17,
    y: 229.52,
    width: 17.655,
    height: 26.483
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 247.17,
    y: 397.24,
    width: 17.655,
    height: 26.483
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 326.62,
    y: 317.79,
    width: 26.483,
    height: 17.655
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158.9,
    y: 317.79,
    width: 26.483,
    height: 17.655
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M220.69,167.724c-5.297,0-8.828-3.531-8.828-8.828v-26.483c0-5.297,3.531-8.828,8.828-8.828 s8.828,3.531,8.828,8.828v26.483C229.517,164.193,225.986,167.724,220.69,167.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M256,167.724c-5.297,0-8.828-3.531-8.828-8.828v-26.483c0-5.297,3.531-8.828,8.828-8.828 s8.828,3.531,8.828,8.828v26.483C264.828,164.193,261.297,167.724,256,167.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M291.31,167.724c-5.297,0-8.828-3.531-8.828-8.828v-26.483c0-5.297,3.531-8.828,8.828-8.828 s8.828,3.531,8.828,8.828v26.483C300.138,164.193,296.607,167.724,291.31,167.724z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F8C787"
    },
    points: "185.379,203.034 326.621,203.034 326.621,158.897 185.379,158.897 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M15.89,167.724c2.648,0.883,4.414,0.883,7.062,0.883h86.51c15.007,0,28.248-9.71,31.779-23.834 c4.414-18.538-7.945-35.31-25.6-37.959c1.766-8.828,1.766-18.538-3.531-29.131c-4.414-7.945-11.476-14.124-19.421-18.538 C57.379,88.276,30.897,125.352,15.89,167.724"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M308.966,476.69c-5.297,0-8.828,3.531-8.828,8.828v21.186c0,0.883,0,0.883,0,1.766 c6.179-0.883,11.476-1.766,17.655-3.531v-19.421C317.793,480.221,314.262,476.69,308.966,476.69"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M282.483,476.69c-5.297,0-8.828,3.531-8.828,8.828v24.717c0,0,0,0,0,0.883 c6.179,0,11.476-0.883,17.655-1.766v-23.834C291.31,480.221,287.779,476.69,282.483,476.69"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M256,476.69c-5.297,0-8.828,3.531-8.828,8.828V512c2.648,0,6.179,0,8.828,0c2.648,0,6.179,0,8.828,0 v-26.483C264.828,480.221,261.297,476.69,256,476.69"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M229.517,476.69c-5.297,0-8.828,3.531-8.828,8.828v23.834c6.179,0.883,11.476,1.766,17.655,1.766 c0,0,0,0,0-0.883v-24.717C238.345,480.221,234.814,476.69,229.517,476.69"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDAE76"
    },
    d: "M203.034,476.69c-5.297,0-8.828,3.531-8.828,8.828v18.538c5.297,1.766,11.476,2.648,17.655,3.531 c0-0.883,0-0.883,0-1.766v-20.303C211.862,480.221,208.331,476.69,203.034,476.69"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.52,
    y: 185.38,
    style: {
      fill: "#DDAE76"
    },
    width: 17.655,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.83,
    y: 185.38,
    style: {
      fill: "#DDAE76"
    },
    width: 17.655,
    height: 17.655
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a587525b807602a2d50c3c077ec5509f.svg";
export { ForwardRef as ReactComponent };